import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { AuthProvider } from './contexts/AuthContext'
import { LanguageProvider } from './contexts/LanguageContext'
import './styles.css'

if ('serviceWorker' in navigator && import.meta.env.PROD) window.addEventListener('load',()=>{navigator.serviceWorker.register('/sw.js').catch(console.error)})
createRoot(document.getElementById('root')!).render(<StrictMode><LanguageProvider><AuthProvider><App/></AuthProvider></LanguageProvider></StrictMode>)
